import { Model, modelRegistry } from './Model';
import { apiService } from '../services/ApiService';
import { Store } from '../wrappers';
import moment from 'moment-timezone';
export class Notification extends Model {
    static entity = 'notifications';
    id = null;
    type = null;
    notifiable_id = null;
    notifiable_type = null;
    code = null;
    text = null;
    data = {};
    read_at = null;
    created_at = null;
    updated_at = null;
    created_by_user_id = null;
    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(null),
            notifiable_id: this.attr(null),
            notifiable_type: this.attr(null),
            code: this.attr(null),
            text: this.attr(null),
            data: this.attr({}),
            read_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            created_by_user_id: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    static unread() {
        return Notification.all().filter(notification => !notification.read_at);
    }
    static async fetchUnread() {
        if (!Store.get('isOnline'))
            return;
        const response = await apiService.get('/notifications', {
            params: {
                status: 'unread',
                limit: 10
            }
        });
        Notification.insert({ data: response.data.notifications });
    }
    async markAsRead() {
        this.read_at = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        this.$save();
        const response = await apiService.post('/notifications/seen', { notification: this.id });
        if (response.data.notification) {
            Notification.update(response.data.notification);
        }
    }
}
export default Notification;
modelRegistry.register('Notification', Notification);
//# sourceMappingURL=Notification.js.map